import { useHistory, useLocation } from 'react-router-dom';
import H from 'history';
import { getLocale, getPathWithoutLocale } from 'helpers/path-helpers';

interface UseNavReturnType extends H.History {
  goTo: (path: string, state?: object) => void;
  changeLanguage: (lang: string) => () => void;
  getPath: (path?: string) => string;
  locale: string;
}

export default function useNav(): UseNavReturnType {
  const history = useHistory();
  const { search } = useLocation();
  const locale = getLocale(history.location.pathname);

  const goTo = (path: string, state?: object): void => {
    const nextPath = search
      ? `/${locale}${path}${search}`
      : `/${locale}${path}`;
    history.push(nextPath, state);
  };

  const changeLanguage = (lang: string) => () => {
    const path = getPathWithoutLocale(history.location.pathname);
    // history.push(`${lang !== DEFAULT_LOCALE ? `/${lang}` : ''}${path}`);
    history.push(`/${lang}${path}`);
  };

  const getPath = (path: string = ''): string => {
    return `/${locale}${path}`;
  };

  return {
    ...history,
    locale,
    goTo,
    changeLanguage,
    getPath,
  };
}
